<template>
  <div class="section" >
     <h1>I Can't find my Convict</h1>
     <div class="issues">
     <div v-for="(issue,is) in issues" :key="'issue'+is" >
      <div class="expandIssue">
        <h2>{{ issue.issue }}</h2>
        <div class="expandBtn" @click="issue.vis=!issue.vis">{{ issue.vis ? '-' : '+' }}</div>
      </div>
      <div v-if="issue.vis" class="issueAns">
        <h2>{{ issue.ans }}</h2>
      </div>
      </div>
     
    </div>
    </div>
    
  
  
</template>

<script>



import CustomButton from "@/components/CustomButton.vue";

export default {
  name: "FindView",
  mixins: [],
  components: {

    CustomButton,
  },
  data() {
    return {
      issues:[
      {issue:"Your Convict may not be in this record set.",vis:false,ans:"We only hqave the convicts sent to Van Diemen's Land as convicts your person may have been transported to Ausdtralia but arrived in Tasmania as a free settler."},  
       {issue:"You may not have enough information to find your convict.",vis:false,ans:"There may be many convicts with the same name. you may need to find some more information about your convict to help narrow down the search."},  
       {issue:"The record may have a different spelling",vis:false,ans:"Try different spellings of the name, or try searching with just the first name and the first few letetrs of the lastname"}, 
       {issue:"The record may be missing",vis:false,ans:"Occasionally records were removed by descendants or volumes may have been lost."},
    ],
      issuesX:[
        "Try searching with different spellings of the name",
        "Try searching with a different first name or initials",
        "Try searching with a different age",
        "Try searching with a different year of arrival",
        "Try searching with a different ship name",
        "Try searching with a different crime",
        "Try searching with a different year of birth",
        "Try searching with a different place of birth",
        "Try searching with a different year of conviction",
        "Try searching with a different place of conviction",
      ]
    }
  },
  mounted() {
    console.log("MOUNTED")
    
  },
  created() {
    console.log("created")
  },
  computed: {
    
    
   
  },
  methods: {
    goBack(){
      this.$router.push("/find")
    }
  },
  watch:{
    
  }
};
</script>

<style lang="scss" scoped>
.expandIssue{
  font-size: 1.3em;
  width:98%;
}
.expandBtn{
  float: right;
  font-size: 2em;
  line-height: 0.5em;
  margin-right: 0.5em;
  margin-top: -1.25em;
  cursor: pointer;
}
.issueAns{
  width:80%;
  margin-bottom: 2em;
  color:#aaa;
}
.issues{
  width:90%;

  margin-top: 0em;
  h2{
    font-size: clamp(1.25em, 3.5vw, 1.5em);
    text-align: left;
    font-weight: 400;
    margin-bottom: 0.5em;
    line-height: 1.2em;
  }
}
</style>
